import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefreshCrossedOut = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(1.4697 1.4697)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M21.0605 20L20 21.0605L16.8701 17.9307C15.1696 19.4013 12.9539 20.2803 10.5303 20.2803H10.5273C7.81779 20.2701 5.21665 19.2124 3.26855 17.3291L2.28027 16.3408V19.5303H0.780273V14.5303C0.780273 14.1161 1.11606 13.7803 1.53027 13.7803H6.53027V15.2803H3.34082L4.31152 16.251C5.9809 17.8648 8.20941 18.7701 10.5312 18.7793C12.5463 18.7791 14.3847 18.0659 15.8076 16.8682L0 1.06055L1.06055 0L21.0605 20ZM10.5332 0.780273C13.0735 0.789856 15.5181 1.71967 17.4189 3.3877L17.792 3.73145L18.7803 4.71973V1.53027H20.2803V6.53027C20.2803 6.94449 19.9445 7.28027 19.5303 7.28027H14.5303V5.78027H17.7197L16.749 4.80957L16.4297 4.51562C14.8006 3.08592 12.7055 2.28867 10.5283 2.28027C9.60882 2.28048 8.72205 2.42731 7.9043 2.70898L7.41602 1.29102C8.39767 0.952894 9.45049 0.780273 10.5303 0.780273H10.5332Z",
			fill: "currentColor"
		})
	})
});
export default SvgRefreshCrossedOut;
